// 主题 hook - 用于在深色模式下获取正确的颜色
import { useApp } from '../context/AppContext'

// 主题颜色映射
const lightTheme = {
  bgPrimary: '#F5F6FA',
  bgWhite: '#ffffff',
  bgCard: '#ffffff',
  bgHover: '#f5f5f5',
  textPrimary: '#1a1a2e',
  textSecondary: '#636e72',
  textMuted: '#b2bec3',
  textPlaceholder: '#999',
  borderColor: 'rgba(0,0,0,0.06)',
  borderColorStrong: 'rgba(0,0,0,0.04)',
  borderColorLight: '#f0f0f0',
  shadowColor: '0 4px 20px rgba(108,99,255,0.08)',
  shadowColorDark: '0 4px 20px rgba(0,0,0,0.08)',
  progressBg: '#EEF0FF',
}

const darkTheme = {
  bgPrimary: '#1a1a2e',
  bgWhite: '#252542',
  bgCard: '#252542',
  bgHover: '#2d2d4a',
  textPrimary: '#ffffff',
  textSecondary: '#a0a0b8',
  textMuted: '#6b6b8a',
  textPlaceholder: '#555577',
  borderColor: 'rgba(255,255,255,0.06)',
  borderColorStrong: 'rgba(255,255,255,0.04)',
  borderColorLight: '#3a3a5e',
  shadowColor: '0 4px 20px rgba(0,0,0,0.3)',
  shadowColorDark: '0 4px 20px rgba(0,0,0,0.4)',
  progressBg: '#3a3a5e',
}

export function useTheme() {
  const { darkMode } = useApp()
  const theme = darkMode ? darkTheme : lightTheme
  
  return {
    ...theme,
    isDark: darkMode,
    // 便捷方法
    bg: theme.bgPrimary,
    card: theme.bgCard,
    text: theme.textPrimary,
    secondary: theme.textSecondary,
    muted: theme.textMuted,
  }
}

// 便捷函数 - 直接获取颜色值
export function getThemeColor(darkMode, colorKey) {
  const t = darkMode ? darkTheme : lightTheme
  return t[colorKey] || t.bgPrimary
}
